/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import { subscribe, unsubscribe, setScroll, openWindow, getConfig } from '../twd/twd'

const $ = global.$

export const adjustView = ({view:view_, args:args_}) => {
    let view = view_
    let args = args_ || {}
    let modal = ''
    let modalArgs = {}

    if (view==='bond-detail'
        && getConfig('entitlements.ETradeBondDetail', 'No') !== 'Yes'
    ) {
        view = 'tools'
        args.view = 'tools.bond-detail'
    }
    else if (view==='tools'
        && args.view==='tools.bond-detail'
        && getConfig('entitlements.ETradeBondDetail', 'No') === 'Yes'
    ) {
        view = 'bond-detail'
    }
    else if (view==='tools'
    && args.view==='tools.bond-portfolio-report'
    ) {
        view = 'portfolio-report'
    }
    else if (view==='tools'
        && args.view==='tools.treasury-auctions'
        && getConfig('entitlements.ETradeTreasuryAuctions', 'No') === 'Yes'
    ) {
        view = 'treasury-auctions'
    }
    else if (view==='tools'
        && args.view==='tools.get-a-bond-quote'
        && getConfig('entitlements.ETradeOrderTicket', 'No') === 'Yes'
    ) {
        view = 'order-ticket'
        args.actionSubset = 'WF'
        args.ts = Date.now()
    }
    else if (view==='tools'
        && args.view==='tools.load-url'
        && args.url
        && args.url.indexOf('pkg_etrade.order_detail')>0
        && getConfig('entitlements.ETradeViewOrders', 'No') === 'Yes'
    ) {
        const url = new URL(args.url)
        view = 'orders'
        args = { view: 'orders' }
        modal = 'order-detail'
        modalArgs = {
            view: 'order-detail',
            action: '?',
            orderNo: url.searchParams.get('p_order_no'),
        }
    }
    else if (view==='sell-your-bond'
        && getConfig('entitlements.ETradeOrderTicket', 'No') === 'Yes'
    ) {
        view = 'order-ticket'
        args.action = 'S'
        args.sourceAction = 'H'
    }

    return [view, args, modal, modalArgs]
}


export default ({args, modal, modal2, setView, setArgs, setModal, setModalArgs, setModal2, setModal2Args, setIs401}) => {
    const modalRef = React.useRef(modal)
    const modal2Ref = React.useRef(modal2)

    React.useEffect(() => {
        modalRef.current = modal
        modal2Ref.current = modal2
    }, [modal, modal2])

    React.useEffect(() => {
        let subId = subscribe('goto.app', (args={}) => {
            if (typeof args === 'string') {
                const [view, hash] = args.split('/')
                args = {view, ...(hash && {hash})}
            }

            let dest = args.view
            if (!dest) return

            if (dest==='401') {
                setIs401(true)
                return
            }

            $('.tooltip').remove()

            const view = dest.split('.')[0]

            const [v, a] = adjustView({view, args})
            if (v) {
                setArgs(a)
                setView(v)
            }

            $('#main')[0].scrollIntoView()
        })

        return () => {
            unsubscribe(subId)
        }
    }, [])


    React.useLayoutEffect(() => {
        if (!args.hash) return
        setScroll(`#${args.hash}`)
    }, [args])

    React.useEffect(() => {
        let subId = subscribe('modal.app', (args={}) => {
            args = typeof args==='string' ? {view:args} : args

            let dest = args.view
            args.ts = Date.now()
            if (!dest) {
                if (modal2Ref.current) {
                    setModal2Args(null)
                    setModal2(null)
                    return
                }

                setModalArgs(null)
                setModal(null)
                return
            }

            const view = dest.split('.')[0]
            const useModal2 = !!modalRef.current
            if (useModal2) {
                setModal2Args(args)
                setModal2(view)
                return
            }

            setModalArgs(args)
            setModal(view)
        })

        return () => {
            unsubscribe(subId)
        }
    }, [])

    React.useEffect(() => {
        let subId = subscribe('open.app', (args={}) => {
            args = typeof args==='string' ? {url:args} : args
            let { url, name, options } = args
            openWindow(url, name, options)
        })

        return () => {
            unsubscribe(subId)
        }
    }, [])

    React.useEffect(() => {
        let subId = subscribe('error-boundary.app', (args={}) => {
            setView('overview')
        })

        return () => {
            unsubscribe(subId)
        }
    }, [])
}
